import { FC } from "react";
import SmartSearchDateIntervalSelectAndActionsLayout from "../../../components/Layouts/smart-search-date-interval-select-and-actions-layout";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import {
  GetRevenueByPeriodParams,
  getRevenueByPeriod,
} from "../../../services/reports";
import { DateFormatEnum } from "../../../enums/dateFormatEnum";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";

const ReportRevenueByPeriod: FC = () => {
  return (
    <SmartSearchDateIntervalSelectAndActionsLayout
      searchBy={[
        SearchOptionEnum.DISTRIBUTOR,
        SearchOptionEnum.CHARITY,
        SearchOptionEnum.LOCATION,
      ]}
      actions={[ActionButtonEnum.REFRESH]}
      selectProps={{
        options: [
          { value: "Day", name: "Day" },
          { value: "Week", name: "Week" },
          { value: "Month", name: "Month" },
          { value: "Year", name: "Year" },
        ],
        label: "Group by",
      }}
      validOnEmpty
      onRefresh={(
        output,
        params,
        startDateInterval,
        endDateInterval,
        select
      ) => {
        const getRevenueByPeriodParams: GetRevenueByPeriodParams = {
          output,
          beginDate: startDateInterval.format(DateFormatEnum.YEAR_MONTH_DAY),
          endDate: endDateInterval.format(DateFormatEnum.YEAR_MONTH_DAY),
          day_week_month_year_select: select as string,
        };

        if (params.id) {
          const id = createIdFromSmartSearchParams(params);
          getRevenueByPeriodParams[id] = params.id;
        }

        return getRevenueByPeriod(getRevenueByPeriodParams);
      }}
    />
  );
};

export default ReportRevenueByPeriod;
